import React from 'react'
import PropTypes from 'prop-types'
import {Card,CardContent,CardActions,CardMedia,IconButton,withStyles,Zoom,Divider} from '@material-ui/core'
import AddIcon from '@material-ui/icons/Add';
import {Muted} from "../";
import {primaryColor} from "../../assets/jss/material-dashboard-react"

export const NewSurveyTile = ({...props})=> {

    const {classes,onClick} = props

    return (
        <Zoom in={true}>
            <Card style={{height: 140}} className={classes.card} onClick={onClick}>
                <CardContent className={classes.cardContent}>
                <CardMedia 
                image="/static/images/cards/paella.jpg"
                title="Start a New Campaign">
                    <AddIcon style={styles.addIcon}/>
                    {/* <p className={classes.titleText}>Start a new survey</p> */}
                    </CardMedia>
                </CardContent>
            </Card>
        </Zoom>
    )
}

const styles={
    card:{
        display:"flex",
        width:200,
        height:235,
        justifyContent:"center",
        margin:20,
        cursor: "pointer",
    },
    titleText:{
        fontWeight:"bold"
    },

    cardContent:{
        display:"flex",
        alignItems:"center",
        flexDirection:"column",
        justifyContent:"center",
        paddingTop:"24px"
    },
    addIcon:{
        fontSize:80,
        color:primaryColor
    },

}

export default withStyles(styles)(NewSurveyTile);


// WEBPACK FOOTER //
// ./src/components/SurveyTile/NewSurveyTile.jsx